/**
 * useAnalyticsData Hook
 * 
 * React Query hook for fetching GA4 analytics data.
 * Migrated from seo-engine-webtools-customer-module
 */

import { useQuery } from '@tanstack/react-query';
import { getAnalyticsData, GetAnalyticsParams } from '@/services/customer/analyticsApi';
import { AnalyticsSummaryResponse } from '@/types/customer';
import { useSiteStore } from '@/store/site.store';

export interface UseAnalyticsDataOptions extends GetAnalyticsParams {
  siteId?: number;
  enabled?: boolean;
}

export function useAnalyticsData(options: UseAnalyticsDataOptions) {
  const selectedSite = useSiteStore((state) => state.selectedSite);
  const siteId = options.siteId ?? selectedSite?.id ?? 1;

  return useQuery<AnalyticsSummaryResponse, Error>({
    queryKey: ['customer-analytics', siteId, options.startDate, options.endDate, options.groupBy],
    queryFn: () => getAnalyticsData(siteId, {
      startDate: options.startDate,
      endDate: options.endDate,
      groupBy: options.groupBy,
    }),
    enabled: options.enabled !== false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export default useAnalyticsData;
